import { render } from "./Teaser.vue?vue&type=template&id=f0df46ba&scoped=true"
import script from "./Teaser.vue?vue&type=script&lang=js"
export * from "./Teaser.vue?vue&type=script&lang=js"

import "./Teaser.vue?vue&type=style&index=0&id=f0df46ba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0df46ba"]])

export default __exports__